import useAPI from '@/pages/members/hooks/useAPI';
import {
  ProgramRepository,
  TreatableTreatmentPreferenceParams
} from '@/repositories/members/ProgramRepository';

import { ONBOARDING_QUERY_KEY_PREFIX } from '../pages/Onboarding/components/Stepper';

export const useTreatableTreatmentPreferences = ({
  drug_category,
  jurisdiction
}: TreatableTreatmentPreferenceParams) => {
  const programRepository = ProgramRepository();

  return useAPI({
    queryKey: [
      ONBOARDING_QUERY_KEY_PREFIX,
      'treatableTreatmentPreferences',
      drug_category,
      jurisdiction
    ],
    queryFn: () =>
      programRepository.listTreatableTreatmentPreferences({ drug_category, jurisdiction }),
    enabled: !!drug_category && !!jurisdiction
  });
};
